import { render, staticRenderFns } from "./PermissionEditDialog.vue?vue&type=template&id=debdb550&scoped=true"
import script from "./PermissionEditDialog.vue?vue&type=script&lang=js"
export * from "./PermissionEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debdb550",
  null
  
)

export default component.exports